export const STAGE_WIDTH = 700;
export const STAGE_HEIGHT = 1000;
export const TILE_X_STARTING_POSITION_MARGIN = 50;
export const TILE_SPRITE_MARGIN = 10;
export const MAX_FLICK_SPEED = 300;
export const SCREEN_BOUNDARY_MARGIN = 50;
export const LEVEL_DURATION_MS = 60000;
export const FLICK_UPDATE_THRESHOLD = 150;
export const MIN_SCORE_FOR_LOSS = -10;
export const VIDEO_STATE_WARMUP_THRESHOLD = 2;
export const VIDEO_STATE_CORRECT_ACTIONS_INITIAL_THRESHOLD = 0;
export const VIDEO_STATE_INCORRECT_ACTIONS_INITIAL_THRESHOLD = 0;
export const VIDEO_STATE_CORRECT_ACTIONS_STREAK_THRESHOLD = 2;
export const VIDEO_STATE_INCORRECT_ACTIONS_STREAK_THRESHOLD = 2;
export const CHOICE_RESULT_INDICATOR_DESTROY_AFTER_STEPS = 80;

export const GLOBAL_STATE_DEFAULT = {
	score: 0,
	maxScore: 0,
	allTimeMaxScore: 0,
	level: 1,
	maxLevel: 1,
	allTimeMaxLevel: 0,
	maxTileGenerationDelay: 3000,
	gameState: 'loading',
	gameStartTime: Date.now(),
	maxTileValue: 50,
	maxSequentialCorrectActions: 0,
	maxSequentialIncorrectActions: 0,
	totalCorrectActions: 0,
	totalIncorrectActions: 0,
	streakTotalActionsAtLastUpdate: 0,
};

export const namedGameResources: { [key: string]: string } = {
	'splashScreenBackground': './splashScreenBackground.png',
	'instructionScreenBackground': './instructionScreenBackground.png',
	'loseScreenBackground': './loseScreenBackground.png',
	'gameBackground': './gameBackground.png',
	'backgroundOverlay': './backgroundOverlay.png',
	'tileGraphic': './tileGraphic.png',
	'startButton': './startButton.png',
	'instructionsButton': './instructionsButton.png',
	'instructionsExitButton': './instructionsExitButton.png',
	'playAgainButton': './playAgainButton.png',
	'happyFace': './happyFace.png',
	'sadFace': './sadFace.png',
	'statusSuccess1': './statusImages/success1.mp4',
	'statusSuccess2': './statusImages/success2.mp4',
	'statusSuccess3': './statusImages/success3.mp4',
	'statusSuccess4': './statusImages/success4.mp4',
	'statusSuccess5': './statusImages/success5.mp4',
	'statusSuccess7': './statusImages/success7.mp4',
	'statusSuccess8': './statusImages/success8.mp4',
	'statusSuccess9': './statusImages/success9.mp4',
	'statusSuccess10': './statusImages/success10.mp4',
	'statusSuccess11': './statusImages/success11.mp4',
	'statusFail1': './statusImages/fail1.mp4',
	'statusFail3': './statusImages/fail3.mp4',
	'statusFail4': './statusImages/fail4.mp4',
	'statusFail5': './statusImages/fail5.mp4',
	'statusFail6': './statusImages/fail6.mp4',
	'statusFail7': './statusImages/fail7.mp4',
	'statusFail8': './statusImages/fail8.mp4',
	'statusFail9': './statusImages/fail9.mp4',
	'statusFail10': './statusImages/fail10.mp4',
	'statusFail11': './statusImages/fail11.mp4',
	'statusStart1': './statusImages/start1.mp4',
	'noiceVideo1': './statusImages/noice1.mp4',
	'noiceVideo2': './statusImages/noice2.mp4',
	'noiceVideo3': './statusImages/noice3.mp4',
	'noiceVideo4': './statusImages/noice4.mp4',
	'noiceVideo5': './statusImages/noice5.mp4',
};
